import { Component } from '@angular/core';

@Component({
  selector: 'snk-root',
  template: `
    <router-outlet></router-outlet>
  `
})
export class AppComponent {}
